// 该文件导出内容只能在小程序上下文被调用

export const getWxUtil = name => {
  if (!process.env.isMiniprogram) {
    throw new Error('Can not use beside wx mp env');
  }
  // eslint-disable-next-line
  const utils = require('@tencent/imwxutils');
  return utils[name];
};

export const isLogin = () => {
  const getCookie = getWxUtil('getCookie');
  const uidType = parseInt(getCookie('uid_type'), 10);
  return uidType === 1002 || uidType === 20000;
};

const splitCookiesString = cookiesString => {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== 'string') {
    return [];
  }

  const cookiesStrings = [];
  let pos = 0;
  let start;
  let ch;
  let lastComma;
  let nextStart;
  let cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== '=' && ch !== ';' && ch !== ',';
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ',') {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === '=') {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
};

const useSetCookie = (ctx, next) => {
  // 回写 set-cookie 头
  return next().then(res => {
    const setCookieHeader =
      res.header['set-cookie'] || res.header['Set-Cookie'] || '';
    // 这里的 , 号分隔很奇怪，已经反馈给微信方
    // 示例 test=,whistle_nohost_env=edu;
    // Expires=Thu, 15 Nov 2018 05:13:12 GMT; Max-Age=259200; Path=/; Domain=.qq.com
    console.log('----cookie str----', setCookieHeader);
    const cookies = splitCookiesString(setCookieHeader).map(str => {
      return str.split(/;\s*/).reduce((acc, cur, i) => {
        const [key, value] = cur.split('=');

        if (i === 0) {
          return {
            ...acc,
            key,
            value,
          };
        }

        return {
          ...acc,
          [key.toLowerCase()]: value,
        };
      }, {});
    });

    const cookieJar = {}; // key => domain

    cookies.forEach(({ domain, key, value }) => {
      if (cookieJar[key] && cookieJar[key].indexOf(domain) >= 0) {
        // 子域优先
        return;
      }
      cookieJar[key] = domain;
      getWxUtil('setCookie')(key, value);
    });
    return res;
  });
};

if (process.env.isMiniprogram) {
  const middlewares = getWxUtil('middlewares');
  middlewares.push(useSetCookie);
}
